import moment from 'moment-timezone';
import { Product } from 'models/product';

export const getLatestFeatureRecurrenceStartDateLocal = (product: Product | undefined): string => {
  const today = moment().format('YYYY-MM-DD');

  const ranges: { start: string; end: string }[] = [];
  for (let i = 0; i < (product?.recurrence || []).length; i++) {
    ranges.push({
      start: moment(product?.recurrence[i].start_date_local).format('YYYY-MM-DD'),
      end: moment(product?.recurrence[i].end_date_local).format('YYYY-MM-DD'),
    });
    for (let j = 0; j < (product?.recurrence[i].additional_date_ranges || []).length; j++) {
      ranges.push({
        start: moment(product?.recurrence[i].additional_date_ranges[j].start_date_local).format(
          'YYYY-MM-DD'
        ),
        end: moment(product?.recurrence[i].additional_date_ranges[j].end_date_local).format(
          'YYYY-MM-DD'
        ),
      });
    }
  }

  let latestFeatureStartDate = '';
  for (let i = 0; i < ranges.length; i++) {
    const startDate = ranges[i].start;
    const endDate = ranges[i].end;
    if (endDate < today) {
      continue;
    }
    if (startDate <= today && today <= endDate) {
      latestFeatureStartDate = today;
      break;
    }
    if (today < startDate) {
      if (!latestFeatureStartDate || startDate < latestFeatureStartDate) {
        latestFeatureStartDate = startDate;
      }
    }
  }

  return latestFeatureStartDate;
};
